import { useContext } from "react";
import { LandingContext } from "../context/Landing";


const useLanding = () => {
    return useContext(LandingContext)
}

export default useLanding